import CreateNew from "../containers/CreateNew";
import launchModal from "./launchModal";

export default function createNew(modal, New = CreateNew) {
  return launchModal(modal, New);
}



// WEBPACK FOOTER //
// ./app/modules/shared/decorators/createNew.jsx